import { notification } from "antd";
import api from "../services/api";

/**
 * Abre o recibo de uma carga. O endpoint é admin-only e devolve uma signed URL
 * curta em JSON; o `api` injeta o token de auth. Abrimos a URL numa nova aba
 * (ela baixa direto por causa do Content-Disposition: attachment). O interno
 * também pode copiar a URL da aba pra repassar ao usuário.
 */
export const openChargeReceipt = async (
  chargeId: string,
  freire?: any,
  texts?: any
): Promise<void> => {
  try {
    const { data } = await api.get(`/charger_history/${chargeId}/receipt`);
    if (!data?.url) {
      throw new Error("Missing receipt url");
    }
    window.open(data.url, "_blank", "noopener,noreferrer");
  } catch (error: any) {
    const message = freire && texts?.OOPS ? freire(texts.OOPS) : "Erro";
    const apiError = error?.response?.data?.error ?? error?.response?.data;
    notification.error({
      message,
      description:
        typeof apiError === "string"
          ? apiError
          : "Não foi possível abrir o recibo.",
    });
  }
};
